<template>
  <div v-if="!isEditMode || (isEditMode && event.id)">
    <a-breadcrumb separator="/">
      <a-breadcrumb-item :to="{ path: '/admin/events' }">Events</a-breadcrumb-item>
      <a-breadcrumb-item>New</a-breadcrumb-item>
    </a-breadcrumb>
    <a-row type="flex" class="area-header">
      <h1 v-if="!isEditMode">New Event</h1>
      <h1 v-else>Edit Event</h1>
    </a-row>
    <div>
      <a-form ref="form" :model="event" label-width="120px" label-position="left">
        <a-form-item>
          <a-checkbox
            :checked="event.isPublic"
            @change="event.isPublic = !event.isPublic"
          >Event is publicly available</a-checkbox>
        </a-form-item>
        <a-form-item label="Link to event" v-if="event.id && event.isPublic">
          <span>{{ publicEventUrl }}</span>
          <a-button
            size="small"
            type="dashed"
            class="_clipboard-btn _d-inline-block _m-l-2"
            :data-clipboard-text="publicEventUrl"
          >Copy</a-button>
        </a-form-item>

        <a-form-item label="Event name">
          <a-input v-model="event.name"></a-input>
        </a-form-item>

        <a-form-item label="Description">
          <a-textarea
            :autosize="{ min: 5, max: 20}"
            placeholder="Enter a brief internal description of the event"
            v-model="event.description"
          ></a-textarea>
        </a-form-item>

        <a-form-item>
          <a-date-picker v-model="event.startAt" format="DD.MM.YYYY"/>
        </a-form-item>
        <a-form-item>
          <a-date-picker v-model="event.endAt" format="DD.MM.YYYY"/>
        </a-form-item>

        <a-form-item label="Project">
          <a-select v-model="event.projectId" placeholder="Project ID">
            <a-select-option
              v-for="project in projects"
              :key="project.id"
              :value="project.id"
            >{{ project.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Floors" v-if="!_.isNil(event.projectId)">
          <draggable
            v-if="Object.keys(event.levels).length > 0"
            v-model="event.levels"
            element="div"
            :options="{handle: '.draggable__handle'}"
          >
            <div
              v-for="(level, index) in event.levels"
              :key="`level-index-${index}`"
              class="draggable draggable--bordered"
            >
              <div class="draggable__handle"></div>
              <div class="_d-flex">
                <a-input placeholder="Floor name" v-model="level.name"></a-input>
                <a-button @click="editLevel(level)" class="_m-l-1">Edit</a-button>
                <a-button type="danger" @click="deleteLevel(index)" class="_m-l-1">
                  <font-awesome-icon :icon="[_app.iconStyle, 'trash']"/>
                </a-button>
              </div>
            </div>
          </draggable>

          <a-button type="primary" @click="addLevel">
            <font-awesome-icon :icon="[_app.iconStyle, 'plus']" class="_m-r-1"/>Add Floor
          </a-button>
        </a-form-item>

        <a-form-item>
          <a-button
            :loading="isLoading"
            type="primary"
            @click="save()"
          >{{ isEditMode ? 'Update' : 'Create' }}</a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-modal
      title="Layout-Editor"
      v-model="isEditorDialogVisible"
      :keyboard="false"
      wrapClassName="layout-editor-modal-wrap"
      centered
    >
      <app-layout-editor
        v-if="currentLevel"
        :currentProject="currentProject"
        :currentLevel="currentLevel"
        @save="onEditorSave"
      ></app-layout-editor>
      <a-button type="primary" @click="saveCurrentLevel">Save</a-button>
    </a-modal>
  </div>
</template>

<script>
import AppLayoutEditor from "@/components/layout-editor/LayoutEditor";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import ClipboardJS from "clipboard";

export default {
  data() {
    return {
      isEditorDialogVisible: false,
      event: {
        isPublic: false,
        startAt: null,
        endAt: null,
        levels: [
          {
            id: this.randomString(),
            name: "Level 1",
            schema: {
              data: {}
            },
            layout: {
              name: "",
              data: {}
            }
          }
        ]
      },
      isLoading: false,
      layoutToEdit: null,
      currentLevel: {
        layout: {},
        schema: {}
      }
    };
  },
  methods: {
    saveCurrentLevel() {
      console.log("saving level", this.currentLevel);
      const level = this.event.levels.find(l => l.id == this.currentLevel.id);
      const index = this.event.levels.indexOf(level);
      this.$set(this.event.levels, index, this.currentLevel);
    },

    async save() {
      this.isLoading = true;

      const event = {
        ...this.event,
        startAt: this.event.startAt
          ? this.event.startAt.format("YYYY-MM-DD HH:mm:ss")
          : null,
        endAt: this.event.endAt
          ? this.event.endAt.format("YYYY-MM-DD HH:mm:ss")
          : null
      };

      try {
        await this.$store.dispatch(`event/saveWithPlan`, {
          levels: this.event.levels,
          event: event
        });
        this.$message.success("Event saved!");
        // this.$router.push({ name: "event-list " });
      } catch (err) {}
      this.isLoading = false;
    },
    addLevel() {
      const level = {
        id: this.randomString(),
        name: "",
        schema: {
          data: {}
        },
        layout: {
          name: null,
          data: {}
        }
      };
      this.event.levels.push(level);
    },
    deleteLevel(index) {
      this.event.levels.splice(index, 1);
    },
    editLevel(level) {
      // this.currentLevel = level;
      // this.layoutToEdit = Object.assign({}, level.layout);
      // this.$store.commit("level/SET_CURRENT_LEVEL", _.cloneDeep(level));
      this.currentLevel = level;
      this.isEditorDialogVisible = true;
    },
    onEditorSave({ layout, schema }) {
      // this.currentLevel.layout = layout;
      this.currentLevel.schema = schema;
      this.currentLevel.layout = layout;
      // this.$store.commit("level/SET_CURRENT_LAYOUT", layout);
    }
  },
  computed: {
    // currentLevel() {
    //   return this.$store.state.level.currentLevel;
    // },
    isEditMode() {
      return this.$route.params.id != "new";
    },
    ...mapGetters("project", {
      projects: "all"
    }),

    currentProject() {
      return this.projects[this.event.projectId];
    },

    publicEventUrl() {
      if (!this.event.id) return false;
      return `${this._app.url}/${this.$_utils.slugify(
        this._user.data.workspace.name
      )}/${this.$_utils.slugify(this.event.name)}-${this.event.id}`;
    }
  },
  async created() {
    this.$store.commit("SET_IS_FETCHING", true);

    try {
      await this.$store.dispatch("project/fetchAll");

      if (this.isEditMode) {
        const event = await this.$store.dispatch("event/fetchSingle", {
          id: this.$route.params.id,
          include: "levels.layout,levels.schema"
        });
        this.$set(
          this,
          "event",
          _.cloneDeep({
            ...event,
            startAt: event.startAt ? this.$moment(event.startAt) : null,
            endAt: event.endAt ? this.$moment(event.endAt) : null
          })
        );
      }
    } catch (e) {}

    this.$store.commit("SET_IS_FETCHING", false);
  },
  mounted() {
    var clip = new ClipboardJS("._clipboard-btn");

    clip.on("success", () => {
      this.$message.info("Link has been copied!", 1.5);
    });
    // console.log(clip);
  },
  components: {
    AppLayoutEditor,
    draggable
  }
};
</script>

<style lang="less">
.editor-wrapper {
  display: flex;
}
.layout-editor-modal-wrap {
  .ant-modal {
    width: 1500px !important;
    max-width: 90vw;
  }
}
</style>
